import { useHistory } from "react-router-dom";
import invariant from "tiny-invariant";
import type { MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { useBroadcastData } from "../../BroadcastDataContext";
import { useEmailMarketingTemplatePaths } from "../TemplatePathContext";
import { useUpdateBroadcastTemplate } from "./useUpdateBroadcastTemplate";

export const useApplyTemplate = () => {
  const {
    mutateAsync: updateBroadcastTemplate,
    isLoading: isUpdatingBroadcastTemplate,
  } = useUpdateBroadcastTemplate();
  const { data: broadcast } = useBroadcastData();
  const history = useHistory();
  const { visualBuilderPath, contentPath } = useEmailMarketingTemplatePaths();

  const handleApplyTemplate = (
    templateId: number,
    templateContentType: MarketingEmailTemplateContentType,
  ) => {
    invariant(broadcast, "Broadcast is required");
    return updateBroadcastTemplate(
      {
        id: broadcast.id,
        body: {
          marketing_email_template_id: templateId,
        },
      },
      {
        onSuccess: () => {
          const path =
            templateContentType === "visual_email_builder"
              ? visualBuilderPath
              : contentPath;

          history.push(path);
        },
      },
    );
  };

  return {
    onApplyTemplate: handleApplyTemplate,
    isApplyingTemplate: isUpdatingBroadcastTemplate,
  };
};
